
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"39.026","height":"32.07"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 7088","d":"M5.999 15.121H8.32v2.321H5.999zm0 7.816H8.32v-2.322H5.999zM20.08 7.521h-2.321v4.025h2.321zm12.381 7.6H30.14v2.321h2.321zm0 5.494H30.14v2.321h2.321zm6.565 10.781a.674.674 0 01-.674.674H.674a.674.674 0 010-1.348h1.961V12.465A2.876 2.876 0 01.694 9.749V4.914h3.664v2.424h.969V4.914h3.664v2.424h.969V4.914h3.664v4.835a2.876 2.876 0 01-1.941 2.716v3.528h2.343v2.515h.957V3.88L18.919 0l3.936 3.88v14.626h.957v-2.515h2.963v-3.526a2.875 2.875 0 01-1.941-2.716V4.914h3.665v2.424h.969V4.914h3.664v2.424h.969V4.914h3.664v4.835a2.876 2.876 0 01-1.941 2.716v18.259h2.527a.674.674 0 01.675.672zm-10.9-15.405h.449v14.731h5.9v-18.1h-.529a.674.674 0 110-1.348h.947a1.525 1.525 0 001.523-1.523V6.263h-.969v2.424h-3.665V6.263h-.969v2.424h-3.664V6.263h-.969v3.488a1.525 1.525 0 001.523 1.523h1.796a.674.674 0 110 1.348h-1.375zm-12.017 2.515h.433v-2.515h4.757v2.515h.433V4.676h-3.773a.562.562 0 110-1.123h2.965l-2-1.976-2.813 2.773zm-3.2 1.123v-2.514h-2.513v13.608h5.155v-3.658a3.374 3.374 0 013.374-3.374 3.374 3.374 0 013.374 3.374v3.66h5.155v-13.61h-2.513v2.515h-4.759v-2.515h-2.513v2.515zM3.988 30.723h5.285V15.991h1.069v-3.373H8.967a.674.674 0 110-1.348h1.793a1.525 1.525 0 001.523-1.523V6.259h-.969v2.424H7.649V6.259H6.68v2.424H3.016V6.259h-.969v3.488A1.525 1.525 0 003.57 11.27h.947a.674.674 0 110 1.348h-.529z","fill":"#088dd1"}})])
          )
        }
      }
    